import { useCallback, useEffect, useRef } from "react"
import { UText } from "@/ui-component"
import { Grid } from "@mui/material"
import { useTranslation } from "react-i18next"
import { DigitalFill } from "./components/DigitalFill"
import { PrintOthers } from "./components/PrintOthers"
import { StageNumber } from "./components/StageNumber"
import { useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { useClinicalSettingsUpdate } from "@/hooks/useClinicalSettingsUpdate"
import { updateDirectPrintAlignerModel } from "@/core/app/slices/user/userSlice"

const DirectPrintAligner = () => {
  const { t } = useTranslation()
  const {
    clinicalSettings: { DPAModel },
  } = useAppSelector((state: RootState) => state.userService)
  const onPrintSettingChange = useClinicalSettingsUpdate()
  const prevDPAModel = useRef(DPAModel)

  // Setup update function
  const updateClinicalSettingsAPI = useCallback(
    (updates: any) => {
      const updatedData = {
        DPAModel: {
          ...updates,
        },
      }
      onPrintSettingChange(updatedData)
    },
    [onPrintSettingChange],
  )
  
  useEffect(() => {
    // Compare current with previous value using deep comparison
    const currentStr = JSON.stringify(DPAModel)
    const prevStr = JSON.stringify(prevDPAModel.current)
    
    if (prevStr !== currentStr) {
      // Only call API if we have a meaningful previous value (skip initial load)
      if (prevDPAModel.current && Object.keys(prevDPAModel.current).length > 0) {
        updateClinicalSettingsAPI(DPAModel)
      }
      // Update previous value for next comparison
      prevDPAModel.current = DPAModel
    }
  }, [DPAModel, updateClinicalSettingsAPI])
    

  return (
    <Grid>
      <Grid>
        <UText variant={"h6"} sxProp={{ color: "#000000" }}>
          {t("stlPrinting.stageNumbertitle")}
        </UText>
        <Grid
          item
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            p: 3,
            gap: 3,
          }}
        >
          <StageNumber
            currPrint={DPAModel}
            updateModel={updateDirectPrintAlignerModel}
          />
        </Grid>
      </Grid>
      <Grid>
        <UText variant={"h6"} sxProp={{ color: "#000000" }}>
          {t("stlPrinting.digitalFill")}
        </UText>
        <Grid
          item
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            p: 3,
            gap: 3,
          }}
        >
          <DigitalFill
            currPrint={DPAModel}
            updateModel={updateDirectPrintAlignerModel}
          />
        </Grid>
      </Grid>
      <Grid>
        <UText variant={"h6"} sxProp={{ color: "#000000" }}>
          {t("stlPrinting.others")}
        </UText>
        <Grid
          item
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            p: 3,
            gap: 3,
          }}
        >
          <PrintOthers
            exportModel={"DPAModel"}
            currPrint={DPAModel}
            updateModel={updateDirectPrintAlignerModel}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default DirectPrintAligner
